import React from "react";
import "./index.css";

function HeroSection() {
  return (
    <>
      <div className="w-full h-screen bg-[#f2f2f2] flex justify-center items-center cursor-zoom-in p-5">
        <img
          src="assets/images/herosection/hero.jpg"
          alt="Hero Image"
          className="f-full max-w-96 max-h-96"
        />
      </div>
    </>
  );
}

export default HeroSection;
